export const paymentCoefficientMessage = (increaseCoefficient: number | string, excessPay: number | string) =>
    `* размер повышающего коэффициента: ${increaseCoefficient}; ** размер превышения платы: ${excessPay} руб.`;

export const noDataMessage = 'Информация за данный период отсутствует, выберите другой период!';
